;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import clsx from 'clsx'
import { Suspense } from 'react'
import { EMAILS } from 'src/core/constants/copy'
import { ErrorBoundary } from 'src/deprecated/components/shared/ErrorBoundary'
import { useSuspenseGetStocklistSources } from 'src/deprecated/hooks/api/useGetStocklistSources'
import { trackDashboardViewAllPriceListsClicked } from 'src/deprecated/utils/report/tracking'

type Props = {
  className?: string
}

function NumberOfCurrentPriceListsInner() {
  const { totalResults } = useSuspenseGetStocklistSources({
    page: 1,
    retry: 0,
  })

  return (
    <div className="flex items-center gap-4">
      <h2 className="typography-header-2xl-bold">
        Price lists ({totalResults})
      </h2>

      <Anchor
        href="/price-lists"
        variant="text"
        color="primary"
        onClick={trackDashboardViewAllPriceListsClicked}
      >
        View all
      </Anchor>
    </div>
  )
}

function Fallback() {
  return (
    <>
      <h2 className="typography-header-2xl-bold">
        Price lists (
        <span className="inline-block w-5 rounded-xs bg-gray-200 motion-safe:animate-pulse">
          &nbsp;
        </span>
        )
      </h2>

      <div className="rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <span className="invisible">View all</span>
      </div>
    </>
  )
}

// TODO: update after design input
function ErrorFallback() {
  return (
    <p>
      <span className="text-base font-medium">
        Unable to retrieve price list information.
      </span>{' '}
      <span className="text-base">
        Please{' '}
        <Anchor
          variant="inline-text"
          href={`mailto:${EMAILS.procurement}`}
          className="inline! [&>span]:inline!"
        >
          email our support team
        </Anchor>{' '}
        if the issue continues.
      </span>
    </p>
  )
}

export function NumberOfCurrentPriceLists({ className }: Props) {
  return (
    <article className={clsx(className, 'flex flex-wrap items-center gap-4')}>
      <Suspense fallback={<Fallback />}>
        <ErrorBoundary fallback={<ErrorFallback />}>
          <NumberOfCurrentPriceListsInner />
        </ErrorBoundary>
      </Suspense>
    </article>
  )
}
